module.exports = __webpack_public_path__ + "img/download.9f724e99.svg";